'use strict';

import React from 'react';

require('styles//QuemSomosPage.css');

class QuemSomosPageComponent extends React.Component {
  render() {
    return (
      <div className="quemsomospage-component">
        <div className="header">
          <h2 className="page-title">Quem Somos</h2>
          <div className="page-description">
            <p>
              A LABOR TEAM tem como missão libertar o CLIENTE para que concentre todos os seus recursos nas actividades que o distinguem. A nossa equipa é constituída por pessoas especializadas nas suas funções e que gostam do seu trabalho.
            </p>
            <p>
              A LABOR TEAM faz um acompanhamento personalizado presencial, por telefone, por email ou por acesso remoto, adaptando-se às diferentes condições e necessidades de cada CLIENTE. Ajudamos cada CLIENTE a crescer em qualidade, conhecimentos, segurança e fiabilidade e a reduzir os custos administrativos e os custos com software de gestão.
            </p>
          </div>
        </div>
        <section>
          <h3 className="section-title">O Que Fazemos</h3>
          <div className="grid">
            <div className="item">
              <div className="icon">
                <img src="/static/images/software.svg" alt="Software"/>
                <h3>Software</h3>
              </div>
              <p>Desenvolvemos software à medida das necessidades do seu negócio.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/assistencia-tecnica.svg" alt="Assistência Técnica"/>
                <h3>Assistência Técnica</h3>
              </div>
              <p>Prestamos assistência técnica ao software por nós representado.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/salarios.svg" alt="Gestão"/>
                <h3>Gestão</h3>
              </div>
              <p>Processamos vencimentos para empresas e gabinetes de contabilidade em regime de outsourcing.</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/mobilidade.svg" alt="Mobilidade"/>
                <h3>Mobilidade</h3>
              </div>
              <p>Desenvolvemos soluções que permitem que trabalhe a partir de qualquer lugar.</p>
            </div>
          </div>
        </section>
        <section>
          <h3 className="section-title">A Nossa Equipa</h3>
          <div className="team-grid">
            <div className="item">
              <div className="icon">
                <img src="/static/images/person.svg" alt="CEO | Consultor - Francisco Pelica"/>
                <h3>CEO | Consultor</h3>
              </div>
              <p>Francisco Pelica</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/person.svg" alt="Serviços Administrativos - Carmo Pelica"/>
                <h3>Serviços Administrativos</h3>
              </div>
              <p>Carmo Pelica</p>
            </div>
            <div className="item">
              <div className="icon">
                <img src="/static/images/person.svg" alt="Recursos Humanos - Isabel Marques"/>
                <h3>Recursos Humanos</h3>
              </div>
              <p>Isabel Marques</p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

QuemSomosPageComponent.displayName = 'QuemSomosPageComponent';

// Uncomment properties you need
// QuemSomosPageComponent.propTypes = {};
// QuemSomosPageComponent.defaultProps = {};

export default QuemSomosPageComponent;



// WEBPACK FOOTER //
// ./src/components/QuemSomosPageComponent.js